import { EnvironmentVariables } from '@environments/model';

export const VARIABLES: EnvironmentVariables = {
  buildTimestamp: 1784297324920,
};
